/**
 * ``cn()`` — class-name helper that resolves Tailwind utility conflicts.
 *
 * ``clsx`` alone concatenates classes; ``tailwind-merge`` then resolves
 * conflicts by keeping the *later* utility from each conflicting group
 * (so a per-instance ``w-20`` correctly overrides a ``w-full`` baked into
 * a base style, regardless of CSS source order).
 *
 * Use this anywhere a component takes both base classes and a caller-
 * supplied ``className`` that may legitimately want to override a width,
 * padding, color, etc. on the component's defaults.
 */
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
